import { TONE } from '../../shared/theme/legacyTones'
// Jurisdições e versões de regras jurídicas das assembleias — tipos tal como o backend os devolve
// (`/api/admin/regras-juridicas`) e as cores de cada estado de validação.

export type EstadoValidacao = 'RASCUNHO' | 'PENDENTE_VALIDACAO' | 'VALIDADA' | 'REVOGADA'

export type AccaoRegras =
    | 'JURISDICAO_CRIADA'
    | 'JURISDICAO_ALTERADA'
    | 'VERSAO_CRIADA'
    | 'VERSAO_EDITADA'
    | 'VERSAO_SUBMETIDA'
    | 'VERSAO_REABERTA'
    | 'VERSAO_VALIDADA'
    | 'VERSAO_REVOGADA'
    | 'VERSAO_VIGENCIA_TERMINADA'

export interface Jurisdicao {
    id: string
    codigo: string
    nome: string
    pais: string | null
    regiao: string | null
    regimeJuridico: string | null
    activa: boolean
    versoes: number
    /** Número da versão validada em vigor hoje; `null` se nenhuma. */
    versaoValidada: number | null
}

export interface JurisdicaoFormData {
    codigo: string
    nome: string
    pais: string
    regiao: string
    regimeJuridico: string
    activa: boolean
}

export interface VersaoResumo {
    id: string
    jurisdicaoId: string
    jurisdicaoCodigo: string
    numero: number
    vigenciaInicio: string
    vigenciaFim: string | null
    estado: EstadoValidacao
    fonteLegal: string | null
    criadaPorNome: string | null
    validadaPorNome: string | null
    validadaEm: string | null
    totalLacunas: number
}

export interface Versao {
    id: string
    jurisdicaoId: string
    jurisdicaoCodigo: string
    jurisdicaoNome: string
    numero: number
    vigenciaInicio: string
    vigenciaFim: string | null
    estado: EstadoValidacao
    fonteLegal: string | null
    referenciaArtigos: string | null
    notas: string | null
    /** O documento de regras em JSON (texto). */
    conteudo: string
    /** Folhas que faltam definir — uma versão só se valida sem lacunas. */
    lacunas: string[]
    completa: boolean
    criadaPorNome: string | null
    editadaPorNome: string | null
    submetidaEm: string | null
    submetidaPorNome: string | null
    validadaPorNome: string | null
    validadaEm: string | null
    revogadaPorNome: string | null
    revogadaEm: string | null
    motivoRevogacao: string | null
    createdAt: string
    updatedAt: string
}

export interface VersaoFormData {
    vigenciaInicio: string
    vigenciaFim: string
    fonteLegal: string
    referenciaArtigos: string
    notas: string
    conteudo: string
}

export interface EventoRegras {
    id: string
    versaoId: string | null
    accao: AccaoRegras
    autorNome: string | null
    motivo: string | null
    antes: string | null
    depois: string | null
    criadoEm: string
}

export const ESTADO_VALIDACAO_LABEL: Record<EstadoValidacao, string> = {
    RASCUNHO: 'Rascunho',
    PENDENTE_VALIDACAO: 'Por validar',
    VALIDADA: 'Validada',
    REVOGADA: 'Revogada',
}

export const ESTADO_VALIDACAO_TONE: Record<EstadoValidacao, { bg: string; color: string }> = {
    RASCUNHO: TONE.muted,
    PENDENTE_VALIDACAO: TONE.warning,
    VALIDADA: TONE.success,
    REVOGADA: TONE.danger,
}

export const ACCAO_LABEL: Record<AccaoRegras, string> = {
    JURISDICAO_CRIADA: 'Jurisdição criada',
    JURISDICAO_ALTERADA: 'Jurisdição alterada',
    VERSAO_CRIADA: 'Versão criada',
    VERSAO_EDITADA: 'Versão editada',
    VERSAO_SUBMETIDA: 'Submetida para validação',
    VERSAO_REABERTA: 'Reaberta para edição',
    VERSAO_VALIDADA: 'Validada',
    VERSAO_REVOGADA: 'Revogada',
    VERSAO_VIGENCIA_TERMINADA: 'Vigência terminada',
}

export const formatData = (value?: string | null) =>
    value ? new Date(value.length === 10 ? `${value}T00:00:00` : value).toLocaleDateString('pt-MZ', { day: '2-digit', month: 'short', year: 'numeric' }) : '—'

export const formatDataHora = (value?: string | null) =>
    value ? new Date(value).toLocaleString('pt-MZ', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—'
